import React from 'react'
import styled, { withTheme } from 'styled-components'
import { CheckIcon } from '@compeon-os/components'
import StyledSubmitButton from 'components/StyledSubmitButton'

const Container = styled.div`
  bottom: 80px;
  left: 0;
  position: fixed;
  text-align: center;

  @media (min-width: 768px) {
    position: initial;
  }
`

const Row = styled.div`
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  transition: background 159ms ease-out;
  font-weight: bold;
  color: white;
  background: ${props => props.background};

  @media (min-width: 768px) {
    background: transparent;
    color: #333;
    border: 2px solid ${props => props.background};
  }
`

const CenteredHint = styled.span`
  text-align: center;
  max-width: 768px;
`

const getHintMessage = ({ touched, isSuitable }) => {
  if (!touched) return 'Bitte beantworten Sie die Fragen, um zu ermitteln, ob KfW-Mittel zur Corona-Hilfe in Frage kommen.'
  if (isSuitable) return 'Auf Basis Ihrer Angaben können Sie KfW-Mittel zur Corona-Hilfe in Anspruch nehmen.'

  return 'Sie können für Ihr Vorhaben keine KfW-Mittel zur Corona-Hilfe in Anspruch nehmen. Holen Sie jetzt Angebote von 250 Finanzierungspartnern ein.'
}

const Hint = ({ isSuitable, touched, isPotentiallySuitable, theme }) => {
  if (touched && !isSuitable && isPotentiallySuitable) return null

  const hintColor = touched
    ? isSuitable ? theme.inputSuccessColor : theme.inputErrorColor
    : theme.primaryColor


  return (
    <Row background={hintColor}>
      {isSuitable && touched && <CheckIcon color='white' size={50} />}

      <CenteredHint>
        {getHintMessage({ touched, isSuitable })}
      </CenteredHint>
    </Row>
  )
}

const Suitability = ({ isSuitable, isPotentiallySuitable, touched, onSubmit, theme }) => (
  <Container>
    {!isPotentiallySuitable && <StyledSubmitButton small onClick={onSubmit}>Finanzierung anfragen</StyledSubmitButton>}

    <Hint
      isPotentiallySuitable={isPotentiallySuitable}
      isSuitable={isSuitable}
      touched={touched}
      theme={theme}
    />
  </Container>
)

export default withTheme(Suitability)
